/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {SpacierArcadeServerDataParser} from "../SpacierArcadeServerDataParser";
import {ISpacierArcadeInitData} from "./ISpacierArcadeServerData";
import {SpacierArcadeGameMode} from "../../gamemode/SpacierArcadeGameMode";
import {FeatureBuyTimesBetValue} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";

export class SpacierArcadeParsedInitData extends ParsedInitData {

    private readonly _nbrOfRowsNextSpin: number;
    private readonly _nbrOfRows: number;
    private readonly _overlaySymbols:string[][];
    private readonly _wildPositions:number[];
    private readonly _overlayWildsMultipliers:number[][];
    private readonly _fsWildPosition: number[];
    private readonly _fsWildPositions: number[][];
    private readonly _spinIntensity:number;
    private readonly _wasFeatureBuy: boolean;
    private readonly _featureBuyTimesBetValue: FeatureBuyTimesBetValue[];

    constructor(rawData: ISpacierArcadeInitData, dataParser: SpacierArcadeServerDataParser) {
        super(rawData, dataParser);

        this._possibleWinWays = dataParser.parsePossibleWinWays(rawData);
        this._payoutMultiplier = dataParser.parsePayoutMultiplier(rawData);

        this._nbrOfRowsNextSpin = dataParser.parseRowsNextSpinCount(rawData);
        this._nbrOfRows = dataParser.parseRowsCurrentSpinCount(rawData);
        this._overlaySymbols = rawData.overlaySymbols;
        this._wildPositions = rawData.wildPositions;
        this._overlayWildsMultipliers = rawData.overlayWildsMultipliers;
        this._fsWildPosition = rawData.fsWildPosition;
        this._fsWildPositions = rawData.fsWildPositions;
        this._spinIntensity = rawData.spinIntensity;
        this._wasFeatureBuy = rawData.wasFeatureBuy;
        this._featureBuyTimesBetValue = rawData.featureBuyTimesBetValue;
    }

    public get featureBuyTimesBetValue(): FeatureBuyTimesBetValue[] {
        return this._featureBuyTimesBetValue;
    }

    public get wasFeatureBuy(): boolean {
        return this._wasFeatureBuy;
    }

    public get spinIntensity():number{
        return this._spinIntensity;
    }

    public get fsWildPosition():number[]{
        return this._fsWildPosition;
    }

    public get fsWildPositions():number[][]{
        return this._fsWildPositions;
    }

    public get overlaySymbols():string[][]{
        return this._overlaySymbols;
    }

    public get overlayWildsMultipliers():number[][]{
        return this._overlayWildsMultipliers;
    }

    public get wildPositions():number[]{
        return this._wildPositions;
    }

    private _payoutMultiplier: number;

    public get payoutMultiplier(): number {
        return this._payoutMultiplier;
    }

    public get numberOfNextActiveRows(): number {
        return this._nbrOfRowsNextSpin;
    }

    public get numberOfActiveRows(): number {
        return this._nbrOfRows;
    }

    private _possibleWinWays: number;

    public get possibleWinWays(): number {
        return this._possibleWinWays;
    }

    protected isFeatureTotalWin(): boolean {
        return this.mode === SpacierArcadeGameMode.RESPIN;
    }

    protected isNextFeatureTotalWin(): boolean {
        return this.nextMode === SpacierArcadeGameMode.RESPIN;
    }
}